import React, { Component } from 'react'
import { isEmpty, pickBy } from 'ramda'

import { Div, H5, ToolTip, Span } from '@driftt/tide-core-legacy'

import { APP_URL } from 'constants/ResourcesConstants'

import './style.styl'

const getHoverText = () => {
  const wordsOfEncouragement = [
    'You’re almost there ⚡️',
    'You got this 💪',
    'Keep going 🚀',
    'Doing great so far 👏',
    'Getting closer 💫',
    'Keep it up 🎉'
  ]

  return wordsOfEncouragement[Math.floor(Math.random() * wordsOfEncouragement.length)]
}

class Onboarding extends Component {
  constructor (props) {
    super(props)

    this.state = {
      showTooltip: false,
      hoverText: getHoverText()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!isEmpty(nextProps.orgProperties)) {
      this.setState({ showTooltip: !nextProps.orgProperties.has_seen_nav_onboarding_tooltip })
    }
  }

  render () {
    const { orgProperties } = this.props
    const { hoverText } = this.state

    // Orgs that go through onboarding start with welcome_org_checklist_completed === false
    if ([undefined, true].includes(orgProperties.welcome_org_checklist_completed)) {return null}

    const onboardingProperties = pickBy((value, key) => /^welcome/.test(key), orgProperties)
    const values = Object.values(onboardingProperties)
    const amtCompleted = values.filter(Boolean).length
    const percentComplete = (amtCompleted / values.length) * 100

    const progressBarStyle = {
      width: `${Math.max(3, percentComplete)}%` // Always show a little nub of progress
    }

    const tooltipProgressBar = (
      <Div className="nav-onboarding-tooltip-progressbar-container">
          <Div style={progressBarStyle} />
        </Div>
    )
  
    const tooltipContent = (
      <Div className="nav-onboarding-tooltip-content">
        <H5 className="nav-onboarding-tooltip-title">Continue setup</H5>
        <H5 className="nav-onboarding-tooltip-title">{percentComplete.toFixed()}% complete</H5>
        {tooltipProgressBar}
        {hoverText}
      </Div>
    )

    return (
      <Div className="nav-help-wrapper nav-status-item nav-status-item-onboarding">
        <ToolTip flow="right" render={() => tooltipContent}>
          <a className="nav-onboarding-link" href={`${APP_URL}/welcome`}>
            <Div className="nav-onboarding-progressbar-container">
              <Div style={progressBarStyle} />
            </Div>
            <Div className="nav-onboarding-percent-completed">
            <Span className="nav-onboarding-percent-completed-number">{percentComplete.toFixed()}</Span>%
            </Div>
          </a>
        </ToolTip>
      </Div>
    )
  }
}

export default Onboarding



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/Onboarding/index.js